import { render } from "./HeroiconsSolidCurrencyPound.vue?vue&type=template&id=1ff011e6"
const script = {}

import exportComponent from "/var/www/vacation-system/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidCurrencyPound.vue"]])

export default __exports__